import React from 'react';
import Border from '../common/border';
import Image from 'next/image';
import ActivityTitle from '../common/ActivityTitle';
import { ActivityWithDay } from '@/types/itineraryTypes';

interface PickupPointProps {
  activity: ActivityWithDay;
}
const PickupPoint: React.FC<PickupPointProps> = ({ activity }) => {
  // Find the first activity marked as meeting point
  const meetingPoint = activity;

  if (!meetingPoint) return null; // Nothing to render if no meeting point found

  // Handle locations - can be array, single object, or undefined
  const locationsArray = Array.isArray(meetingPoint.locations)
    ? meetingPoint.locations
    : meetingPoint.locations
      ? [meetingPoint.locations]
      : [];

  const firstLocation = locationsArray[0];

  if (!firstLocation) return null; // Nothing to render if no location found

  const imageUrl = firstLocation.imageUrls?.[0];
  const coordinates = firstLocation.coordinates;
  const hasValidCoordinates =
    coordinates &&
    typeof coordinates.lat === 'number' &&
    typeof coordinates.lng === 'number' &&
    !isNaN(coordinates.lat) &&
    !isNaN(coordinates.lng);

  // Don't render if we don't have at least title or description
  if (!meetingPoint.title && !meetingPoint.description) return null;

  return (
    <div>
      <ActivityTitle title='Meeting and Pickup point' className='' />
      <p className='md:text-sm text-xs md:leading-6 leading-none mb-3'>
        You can either go straight to the meeting point
      </p>

      <div className='flex items-start mb-10'>
        {imageUrl && (
          <Image
            src={imageUrl}
            alt={meetingPoint.title || 'Meeting point'}
            width={186}
            height={100}
            className='md:w-[11.625rem] w-36 md:h-[6.25rem] h-full rounded-lg object-cover'
          />
        )}

        <div className='ml-5'>
          {meetingPoint.title && (
            <h6 className='md:text-lg text-sm md:leading-6 leading-5 mb-1.5'>
              {meetingPoint.title}
            </h6>
          )}
          {meetingPoint.description && (
            <p className='md:text-sm text-xs mb-3 text-darkgrey'>
              {meetingPoint.description}
            </p>
          )}
          {hasValidCoordinates && (
            <a
              href={`https://www.google.com/maps?q=${coordinates.lat},${coordinates.lng}`}
              target='_blank'
              rel='noopener noreferrer'
              className='flex items-center gap-1.5'
            >
              <Image
                alt='marker'
                src='/assets/images/svg/marker.svg'
                width={16}
                height={16}
                className='w-4 h-4 flex-shrink-0'
              />
              <span className='font-semibold md:text-sm text-xs'>
                Get Directions
              </span>
            </a>
          )}
        </div>
      </div>

      <Border />
    </div>
  );
};

export default PickupPoint;
